
import axios from "axios";
 
const BaseUrl = axios.create({
    baseURL: 'https://dharajwebbackend.concentics.com',
});
export default BaseUrl;

 
//  import axios from "axios";

// // Define the base domain once
// const DOMAIN = "https://dharajwebbackend.concentics.com";

// // Create axios instance for API calls
// const BaseUrl = axios.create({
//   baseURL: `${DOMAIN}/api`,
// });

// // Export both axios instance and image base URL
// export const IMAGE_BASE_URL = `${DOMAIN}/productimage`;

// export default BaseUrl;
